import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';

import { MediaClazzType, MediaLocation } from '@api/catalog/products/medias/medias.models';
import { ProductsHelpers } from '@api/catalog/products/products.helpers';
import { ProductColor } from '@api/catalog/products/products.models';
import { CommonWindow } from '@core/domain/models/common-window.model';

/**
 * Servicio para las fallback
 */
@Injectable()
export class FallBackImageService {
    constructor(
        @Inject(WINDOW) private readonly window: CommonWindow,
    ) {}

    public getMediaUrl(
        color: ProductColor,
        urlError: string,
        location: MediaLocation,
        imageType: string,
        width?: number,
        impolicy?: string
    ): string {
        let urlResult = '';

        if (urlError.includes('sinImage-double')) {
            urlResult = this.getSingleImage(color, location, width, impolicy);
        } else if (urlError.includes('sinImage-undefined')) {
            urlResult = this.getDoubleImage(color, location, width, impolicy);
        } else {
            urlResult = this.getNextImage(color, urlError, location, imageType, width, impolicy);
        }

        return urlResult;
    }

    private getSingleImage(color: ProductColor, location: MediaLocation, width?: number, impolicy?: string): string {
        const productImages = ProductsHelpers.imagesForColor(this.window, color, location, width, undefined, impolicy);
        return productImages[0].path;
    }

    private getDoubleImage(color: ProductColor, location: MediaLocation, width?: number, impolicy?: string): string {
        const productImages = ProductsHelpers.imagesForColor(this.window, color, location, width, 'double', impolicy);
        return productImages[0]?.path;
    }

    private getNextImage(
        color: ProductColor,
        urlError: string,
        location: MediaLocation,
        imageType: string,
        width?: number,
        impolicy?: string
    ): string {
        const productImages = ProductsHelpers.imagesForColor(
            this.window,
            color,
            location,
            width,
            imageType as MediaClazzType,
            impolicy
        );
        let urlResult = '';
        productImages.forEach((pi, index) => {
            if (pi.path === urlError) {
                if (index < productImages.length - 1) {
                    urlResult = productImages[index + 1].path;
                }
            }
        });
        return urlResult;
    }
}
